module.exports = __webpack_public_path__ + "media/shared/assets/fonts/PlusJakartaSans/PlusJakartaSans-Medium-f82e29a32033740d46163703c7f605ed.woff2";